<template>
  <div>
    <main class="page__container">
      <div class="container">
        <h2>Редактирование Live Stream сервера</h2>
        <el-form ref="form" :rules="rules" :model="form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Название" prop="name">
                <el-input v-model="form.name" size="small" placeholder="Название" />
              </el-form-item>
            </el-col>
            <el-col v-if="!isVk3" :span="6">
              <el-form-item label="ID">
                <span class="form__readonly">{{ form.server_id }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Количество камер" prop="cameras_count">
                <el-input-number id="cameras_count" v-model="form.cameras_count" :min="0" size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Камер на сервере">
                <span class="form__readonly">{{ form.current_cameras_count }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <operators-select v-model="selectedOperators" />
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="API-ключ AVC панели" prop="avc_panel_api_key">
                <el-input v-model="form.avc_panel_api_key" size="small" placeholder="api_key" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Группа серверов" prop="id_server_group">
                <template slot="label">
                  Группа серверов
                </template>
                <el-tooltip class="item" effect="light" placement="top-start">
                  <template slot="content">
                    Группа влияет на <code>rules.conf</code> сервера. Оставить пустым для настроек по умолчанию
                  </template>
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-select
                  v-model="form.id_server_group"
                  size="small"
                  placeholder="Нет группы"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="val in serverGroups"
                    :key="val.id_server_group"
                    :label="val.server_group_name"
                    :value="val.id_server_group"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar page__active_bar--spread">
      <el-button
        v-if="$can('delete', 'proxy_servers')"
        type="danger"
        icon="el-icon-delete"
        :loading="fetch"
        @click="onDelete"
      >
        Удалить сервер
      </el-button>
      <div class="page__active_buttons">
        <el-button
          v-if="$can('update', 'proxy_servers')"
          type="primary"
          :loading="fetch"
          @click="submit"
        >
          Сохранить
        </el-button>
      </div>
    </el-footer>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { length, required } from "@/core/helpers/validators";
import { MEDIA_CORE } from "@/core/helpers/const";
import OperatorsSelect from "./OperatorsSelect";

export default {
  name: "ServerEdit",
  components: {
    OperatorsSelect,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fetch: false,
      serverGroups: [],
      selectedOperators: [],
      rules: {
        name: [required(), length(3, 200)],
        cameras_count: [required("number")],
      },
    };
  },
  computed: {
    ...mapState("servers", {
      form: (state) => state.server,
    }),
    // У MCore имя сервера одновременно является доменом и идентификатором,
    // поэтому ID не показываем (ТЗ 1.2.1).
    isVk3() {
      return this.form.id_media_core === MEDIA_CORE.VK3;
    },
  },
  created() {
    this.getServerGroups()
      .then((res) =>
        this.serverGroups = res
      );
    this.getServer(this.id)
      .then(() =>
        this.selectedOperators = (this.form.operators || []).map((operator) => operator.id_operator)
      );
  },
  methods: {
    ...mapActions("servers", {
      getServerGroups: "GET_SERVER_GROUPS",
      getServer: "GET_SERVER",
      updateServer: "UPDATE_SERVER",
      deleteServer: "DELETE_SERVER",
    }),
    onDelete() {
      this.$confirm("Вы точно хотите удалить сервер?", "Удаление сервера", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        cancelButtonClass: "el-button--success",
        type: "warning",
      })
        .then(() => {
          this.fetch = true;
          return this.deleteServer(parseInt(this.id, 10))
            .then(() => {
              this.$router.push({ name: "servers", params: { page: 1 } });
              this.$message({
                message: "Сервер удалён",
                type: "success",
              });
            })
            .catch(({ response }) => {
              this.$message({
                message: (response && response.data && response.data.error) || "Неизвестная ошибка",
                type: "error",
              });
            })
            .finally(() => {
              this.fetch = false;
            });
        })
        .catch(() => {});
    },
    buildPayload() {
      return {
        name: this.form.name,
        cameras_count: this.form.cameras_count,
        operators: [...this.selectedOperators],
        avc_panel_api_key: this.form.avc_panel_api_key,
        id_server_group: this.form.id_server_group,
      };
    },
    submit() {
      this.$confirm("Вы точно хотите сохранить изменения?", "Подтверждение", {
        confirmButtonText: "Сохранить",
        type: "warning",
      })
        .then(() => {
          let formIsValid;
          this.$refs["form"].validate((status) => {
            formIsValid = status;
          });
          if (!formIsValid) return false;

          this.fetch = true;
          const id = parseInt(this.id, 10);
          return this.updateServer({ id, newServer: this.buildPayload() })
            .then(() => {
              this.$router.push({ name: "servers", params: { page: 1 } });
              this.$message({
                message: "Изменения сохранены",
                type: "success",
              });
            })
            .catch(({ response }) => {
              this.$message({
                message: response.data.error,
                type: "error",
              });
            })
            .finally(() => {
              this.fetch = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Отмена",
          });
        });
    },
  },
};
</script>

<style scoped>
.page_container {
  padding: 20px;
}
.form__readonly {
  color: #606266;
}
.page__active_bar--spread {
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.page__active_buttons {
  display: flex;
  justify-content: flex-end;
  gap: 11px;
  margin-left: auto;
  padding: 11px 0;
}
</style>
